import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'

import { Checkbox } from 'Components/Form/Checkbox'
import { Input } from 'Components/Form/Input'
import { SelectDashboard } from 'Components/Form/SelectDashboard'

import { Map } from 'Components/Map'

import { required } from 'Utils/Validators/formValidation'
import pinIcon from '../../../../../Assets/Images/icons/mission-pin-vector.svg'

class LocationAddFormUnstyled extends React.Component {
  state = {
    currentPosition: {
      latitude: null,
      longitude: null,
    },
    loadingCoords: true,
  }

  componentDidMount() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        this.savePosition,
        this.getCurrentPositionError,
        {
          enableHighAccuracy: true,
          maximumAge: 60000,
          timeout: 4000,
        },
      )
    } else {
      this.getCurrentPositionError()
    }
  }

  savePosition = ({ coords }) => {
    this.props.change('coordinates', coords)
    this.setState({
      currentPosition: coords,
      loadingCoords: false,
    })
  }
  getCurrentPositionError = err => {
    console.warn('LocationAddFormUnstyled > getCurrentPositionError', { err })
    var coordinates = {
      latitude: 0,
      longitude: 0,
    }
    this.props.change('coordinates', coordinates)
    this.setState({
      currentPosition: coordinates,
      loadingCoords: false,
    })
  }
  render() {
    const { className, handleSubmit, locationTypeOptions } = this.props
    const { currentPosition, loadingCoords } = this.state
    return (
      <form className={className} onSubmit={handleSubmit}>
        <Row>
          <Col xs={6}>
            <Field
              component={Input}
              name="name"
              props={{ id: 'name', label: 'Name', placeholder: 'Name' }}
              validate={[required]}
            />
          </Col>
          <Col xs={6}>
            <Field
              component={Input}
              name="label"
              props={{ id: 'label', label: 'Label', placeholder: 'Label' }}
              validate={[required]}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Field
              component={Checkbox}
              name="isEvent"
              props={{ label: 'Event or Weekend' }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Field
              name="typeId"
              component={SelectDashboard}
              props={{
                onChange: this.typeSelectHandler,
                options: locationTypeOptions,
                label: 'Type',
                sorted: true,
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            {loadingCoords ? (
              <span>Loading coordinates, please wait</span>
            ) : (
              <Map
                defaultZoom={14}
                mapPositionLat={Number(currentPosition.latitude)}
                mapPositionLng={Number(currentPosition.longitude)}
                markers={[
                  {
                    markerPositionLat: Number(currentPosition.latitude),
                    markerPositionLng: Number(currentPosition.longitude),
                    onMarkerDragEnd: this.markerDragEndHandler,
                    isMarkerDraggable: true,
                    useDefaultIcon: true,
                    icon: pinIcon,
                  },
                ]}
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={4}>
            <Field
              component={Checkbox}
              name="moments.morning"
              props={{ label: 'Morning' }}
            />
          </Col>
          <Col xs={4}>
            <Field
              component={Checkbox}
              name="moments.lunch"
              props={{ label: 'Lunch' }}
            />
          </Col>
          <Col xs={4}>
            <Field
              component={Checkbox}
              name="moments.afternoon"
              props={{ label: 'Afternoon' }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={4}>
            <Field
              component={Checkbox}
              name="requirePermit"
              props={{ label: 'Needs permit' }}
            />
          </Col>
          <Col xs={4}>
            <Field
              component={Checkbox}
              name="isSheltered"
              props={{ label: 'Sheltered' }}
            />
          </Col>
        </Row>
      </form>
    )
  }

  markerDragEndHandler = e => {
    const { change } = this.props
    const coordinates = {
      latitude: e.latLng.lat(),
      longitude: e.latLng.lng(),
    }

    change('coordinates', coordinates)
  }

  typeSelectHandler = (e, index, value) => {
    const { change } = this.props
    change('typeId', value)
  }
}

LocationAddFormUnstyled.propTypes = {
  initialValues: PropTypes.object.isRequired,
  locationTypeOptions: PropTypes.array.isRequired,
}

LocationAddFormUnstyled = reduxForm({
  form: 'locationAddForm',
})(LocationAddFormUnstyled)

const mapStateToProps = (state, ownProps) => ({
  initialValues: {
    isEvent: false,
    moments: {
      morning: false,
      lunch: false,
      afternoon: false,
    },
    requirePermit: false,
    isSheltered: false,
  },
})

LocationAddFormUnstyled = connect(
  mapStateToProps,
  {},
)(LocationAddFormUnstyled)

export default LocationAddFormUnstyled



// WEBPACK FOOTER //
// ./src/Containers/Form/City/Locations/LocationAdd/unstyled.js